import { __extends } from "tslib";
import { ListChannelMembershipsForAppInstanceUserRequest, ListChannelMembershipsForAppInstanceUserResponse, } from "../models/models_0";
import { deserializeAws_restJson1ListChannelMembershipsForAppInstanceUserCommand, serializeAws_restJson1ListChannelMembershipsForAppInstanceUserCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
/**
 * <p> Lists all channels that a particular <code>AppInstanceUser</code> is a part of. Only an
 *             <code>AppInstanceAdmin</code> can call the API with a user ARN that is not their own. </p>
 *
 *          <note>
 *             <p>The <code>x-amz-chime-bearer</code> request header is mandatory. Use the
 *                <code>AppInstanceUserArn</code> of the user that makes the API call as the value in
 *             the header.</p>
 *          </note>
 * @example
 * Use a bare-bones client and the command you need to make an API call.
 * ```javascript
 * import { ChimeSDKMessagingClient, ListChannelMembershipsForAppInstanceUserCommand } from "@aws-sdk/client-chime-sdk-messaging"; // ES Modules import
 * // const { ChimeSDKMessagingClient, ListChannelMembershipsForAppInstanceUserCommand } = require("@aws-sdk/client-chime-sdk-messaging"); // CommonJS import
 * const client = new ChimeSDKMessagingClient(config);
 * const command = new ListChannelMembershipsForAppInstanceUserCommand(input);
 * const response = await client.send(command);
 * ```
 *
 * @see {@link ListChannelMembershipsForAppInstanceUserCommandInput} for command's `input` shape.
 * @see {@link ListChannelMembershipsForAppInstanceUserCommandOutput} for command's `response` shape.
 * @see {@link ChimeSDKMessagingClientResolvedConfig | config} for command's `input` shape.
 *
 */
var ListChannelMembershipsForAppInstanceUserCommand = /** @class */ (function (_super) {
    __extends(ListChannelMembershipsForAppInstanceUserCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListChannelMembershipsForAppInstanceUserCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    ListChannelMembershipsForAppInstanceUserCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "ChimeSDKMessagingClient";
        var commandName = "ListChannelMembershipsForAppInstanceUserCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: ListChannelMembershipsForAppInstanceUserRequest.filterSensitiveLog,
            outputFilterSensitiveLog: ListChannelMembershipsForAppInstanceUserResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListChannelMembershipsForAppInstanceUserCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1ListChannelMembershipsForAppInstanceUserCommand(input, context);
    };
    ListChannelMembershipsForAppInstanceUserCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1ListChannelMembershipsForAppInstanceUserCommand(output, context);
    };
    return ListChannelMembershipsForAppInstanceUserCommand;
}($Command));
export { ListChannelMembershipsForAppInstanceUserCommand };
//# sourceMappingURL=ListChannelMembershipsForAppInstanceUserCommand.js.map